export default {
    items: [
        {
            translatekey: 'label.dashboard',
            name: '',
            url: '/#',
            icon: 'icon-speedometer',
            // badge: {
            //     variant: 'primary',
            //     text: 'NEW',
            // },
        },
        {
            translatekey: 'label.organization',
            name: '',
            url: '/organization',
            icon: 'icon-organization',
        },
        // {
        //     name: 'Groups',
        //     trans_fullname: 'label.groups',
        //     url: '/groups',
        //     icon: 'icon-layers',
        //     //icon: 'icon-people'
        // },
        {
            translatekey: 'label.tickets',
            name: '',
            url: '/tickets',
            icon: 'icon-notebook',
        },
        {
            translatekey: 'label.forms',
            name: '',
            url: '/forms',
            icon: 'icon-note',
        },
        {
            translatekey: 'label.feedback',
            name: '',
            url: '/feedback',
            icon: 'icon-question',
        },

        // {
        //   name: "Search",
        //   trans_fullname: "label.Search",
        //   url: "/search",
        //   icon: "icon-magnifier"
        // }
    ],
}
